import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {RequestADemoForm} from '../../types';
import {RtPlatformService} from '../../../rt-platform/rt-platform.service';

@Injectable()
export class PublicRequestADemoService {
  constructor(private http: HttpClient, private platform: RtPlatformService) {}

  /**
   * Load submission additional data by submission id.
   */
  public requestADemo(requestADemoForm: RequestADemoForm): Observable<void> {
    const url = `${this.platform.baseUrl}/api/request-demo/`;
    return this.http.post<RequestADemoForm>(url, requestADemoForm).pipe(map(response => null));
  }
}
